module.exports = __webpack_public_path__ + "static/media/como-11.0a01ea60.jpg";